import { FC } from "react";
import { Backdrop } from "@mui/material";
import { LogoSolar } from "src/framework/components/commons/LogoSolar";
import { Theme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Icon } from "@mui/material";
import { orange } from "@mui/material/colors";
import "./style.css";
import { Grid } from "@mui/material";
import theme from "src/theme/light";

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 9000,
      backgroundColor: "rgba(255,255,255,0.74)",
    },
  })
);
export interface CustomLoaderProperties {
    loading: boolean;
}

const CustomLoader: FC<CustomLoaderProperties> = ({
    loading = false
}) => {
  const classes = useStyles();

  return (
    <div>
      <Backdrop open={loading} className={classes.backdrop}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid>
            <Icon
              className="spin"
              style={{ fontSize: "40px", color: orange[500] }}
            >
              wb_sunny
            </Icon>
          </Grid>
          <Grid>
            <LogoSolar fillIntelbras={"#00B26B"} width={"200px"} />
          </Grid>
        </Grid>
      </Backdrop>
    </div>
  );
};

export { CustomLoader };
